import Vue from "vue";
import pinia from "@/vue/shared/store";
import { getTerminal } from '@shared/utils';
import { TERMINAL } from "@shared/constants";
import Lettering from "./Lettering.vue";

const renderLetteringPopup = (dom = '#lettering-popup') => {
  if (getTerminal() == TERMINAL.PC) {
    new Vue({
      el: dom,
      pinia,
      render: (h) => h(Lettering),
    });
  }
}

export default renderLetteringPopup;